module.exports = __webpack_public_path__ + "static/media/icon-user.21aacf10.svg";